import { createContext } from 'react';

export const InternacionesTramitesContext = createContext();
